import React, { Component } from 'react'
import AutoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import Moment from 'Moment';
import { FormGroup } from './../../util/form-group/index';
import Modal from './../../util/modal/index';
import ReactSelect, { components } from 'react-select';
import {
    Consulta_Cola_Venta_Credito_Fiscal, Aplicar_Cola_Venta_Credito_Fiscal, Aplicar_Todo_Cola_Venta_Credito_Fiscal
} from '../../request/rfc';
const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};


export default class Bitacora extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            selectedRow: {},
            disabled: false,
            isChecked: false,
            MasterChecked: false,
            SelectedList: {},
        };
        localStorage.setItem("tipoFactura", '')
        AutoBind(this);
    }

    componentDidMount() {
        this.cargar_Cola_Venta_Credito_Fiscal();
        this.initTable([]);
        const $table = $(this.refs.tblFacturas);
        $table.on('click-row.bs.table', this.onClickTable);
        //$table.on('click-row.bs.table', this.checkedAplicar);
        
    }
    
    
    cargar_Cola_Venta_Credito_Fiscal() {
        Consulta_Cola_Venta_Credito_Fiscal()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ SelectedList: Data });
                    const data = Data.map(item => Object.assign({}, item, { Fecha_Apertura: Moment(item.Fecha_Apertura).format('L') }));
                    this.initTable([]);

                    this.loadTable(data);
                }
            })
            .catch((err) => { console.log(err); });
    }
    

    
    
    initTable(data) {

        const $table = $(this.refs.tblFacturas);
        let _columnas = [];
        _columnas = [{
            title: 'Marcar',
            formatter: function (value, row, index) {
                return '<input type="checkbox" name="Checkbox" id="' + row.Documento +'" value="false" />'
            }
        },{
            title: 'Sucursal',
            field: 'Suc_Id',
            sortable: true
        }, {
            title: 'Documento',
                field: 'Documento'
        }, {
            title: 'Cliente',
            field: 'Cliente_Id',
            sortable: true
            }, {
                title: 'Fecha',
                field: 'Factura_Fecha',
                sortable: true
            }, {
                title: 'Total',
                field: 'Factura_Total',
                cellStyle: function cellStyle(value, row, index, field) {
                    return {
                        css: { "text-align": "right" }
                    };
                }
                
            }, {
                title: 'Mensaje',
                field: 'Fiscal_MensajeError',
                sortable: true
            }, {
                title: 'Estado',
                field: 'Estado',
                sortable: true
            }];
        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 550,
            striped: false,
            pagination: true,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: true,
            toolbar: $('#toolbar'),
            toolbarAlign: 'right',
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: true,
            rowAttributes: function (row) {
                return { 'data-id': row.Documento }

            },
            columns: _columnas
        });
    }

    loadTable(data) {
        const $table = $(this.refs.tblFacturas);
        $table.bootstrapTable('load', data || []);
    }
    

    onAplicar() {
        this.setState({ disabled: true });
        var Aplicar = false;
        for (let i = 0; i < this.state.SelectedList.length; i++) {
            if (this.state.SelectedList[i].Aplicar) {
                Aplicar = this.state.SelectedList[i].Aplicar;
            }

        }
        if (Aplicar) {
            Aplicar_Cola_Venta_Credito_Fiscal({ pDatos: this.state.SelectedList })
                .then(({ data: Response }) => {
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                        this.setState({ disabled: false });
                    } else {
                        this.cargar_Cola_Venta_Credito_Fiscal();
                        this.setState({ disabled: false });
                        alert('La operación ya fue actualizada.');
                    }
                })
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        } else {
            this.setState({ disabled: false });
            alert('Debe seleccionar un documento.');
        }
    }

    onAplicarTodo() {
        Aplicar_Todo_Cola_Venta_Credito_Fiscal()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.cargar_Cola_Venta_Credito_Fiscal();
                    this.setState({ disabled: false });
                    alert('La operación ya fue actualizada.');
                }
            })
            .catch((err) => { console.log(err); });
    }

    onClickTable(row, $element, field) {
        const selectedRow = document.querySelector('tr.table-info');
        if (!!selectedRow)
            selectedRow.classList.remove('table-info');
        if ($element.Factura_Id > 0) {
            document.querySelector(`tr[data-id="${$element.Documento}"]`).classList.add('table-info');
        }
        this.setState({ selectedRow: $element });
        for (let i = 0; i < this.state.SelectedList.length; i++) {
            if ($element.Documento == this.state.SelectedList[i].Documento) {
                this.state.SelectedList[i].Aplicar = field.prevObject[0].firstChild.checked;
            }
            
        }
    }
    
    render() {

        const { baseUrl, disabled,  } = this.state;
        //const OptionsPago = formasdePago.map(item => ({ value: Id, label:Nombre }))
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-12">
                            <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                <i className="fas fa-angle-double-left"></i>
                            </Link>
                        </div>
                    </div>
                   
                    <hr />
                    <div className="row">
                        <div className="col-md-12">
                            <table ref="tblFacturas"></table>
                        </div>
                    </div>
                </div>
                <div id="toolbar">
                    <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onAplicar}>
                        <i className={disabled ? 'fas fa-spinner fa-spin' : 'fas fa-clipboard-check'}></i>
                    </button>
                    <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onAplicarTodo}>
                        <i>Todo</i>
                    </button>
                </div>
                
              
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/bitacora/index.jsx